import api from "./api";

export interface MaterialUploadBatchUploadRequest {
  url: string;
  target: Array<Target>;
};

export interface Target {
  newFolderId: number;
  newTagIds: Array<number>;
};

// 素材库批量上传标签
export async function materialUploadBatchUpload(data: MaterialUploadBatchUploadRequest[]) {
  const res = await api.post('/material_upload/batch_upload', {
    list: data.map(item => ({
      url: item.url,
      target: item.target.map(target => ({
        new_folder_id: target.newFolderId,
        new_tag_ids: target.newTagIds,
      })),
    })),
  });
  return res.data;
}
